/* angular:styles/component:css;2c05b4f651c1c88e10100385d78389d056a25cde3f32ddb3e98fea4dfc715459;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/tasks/map/map.component.ts */
:host {
  width: 100%;
  height: 100%;
}
mgl-map {
  height: 100%;
  width: 100%;
}
#zoom-controls {
  border-radius: 3px;
  position: absolute;
  left: 23px;
  bottom: 40px;
  width: 35px;
  z-index: 10;
}
.control {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  cursor: pointer;
  background-color: white;
}
.control:hover {
  background-color: #eee;
}
/*# sourceMappingURL=map.component.css.map */
